import api from '@/js/services/api';

export default {
    getEventsForAWeek(currentDate) {
        return api().get(`/applicant/calendar/events/get`, {
            params: {
                currentDate: currentDate
            }
        });
    },
    getWorkdaySettings() {
        return api().get(`/applicant/calendar/workday-setting/get`)
    },

    sendAppointmentInfo(applicant_id, event) {
        return api().post (`/applicant/${applicant_id}/calendar/events/create`, event)
    },

    getAppointmentInfo(applicant_id) {
        return api().get(`/applicant/${applicant_id}/calendar/events/get`)
    },

    deleteCurrentAppointment(event_id) {
        return api().delete(`/applicant/calendar/${event_id}/destroy`)
    }

}
